import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { AuthService } from '@/services/AuthService'
@Module({
  namespaced: true,
  name: 'auth',
  store,
  dynamic: true
})
class AuthModule extends VuexModule {
  token = ''
  isAuth = false
  service = new AuthService()

  @Action({ commit: 'setToken' })
  addToken (token: string) {
    return token
  }

  @Action({ commit: 'setToken' })
  removeToken () {
    return ''
  }

  @Mutation
  setToken (token: string) {
    this.token = token
    this.isAuth = token !== ''
  }
}

export default getModule(AuthModule)
